import { render, staticRenderFns } from "./mix-table-block.v2.vue?vue&type=template&id=7646bc36&"
import script from "./mix-table-block.v2.vue?vue&type=script&lang=js&"
export * from "./mix-table-block.v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports